import { Component, OnInit } from '@angular/core';
import { HelpersService } from '../../../../services/helpers.service';
import { PaymentService } from '../../../../services/payment.service';
import { NotificationService } from '../../../../services/notification.service';
import { CountriesService } from '../../../../services/countries.service';
import { AppConfig } from '../../../../app.config';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { StripeBundlePaymentComponent } from '../../../modals/payments/stripe-bundle-payment/stripe-bundle-payment.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-purchase-messaging-bundle',
  templateUrl: './purchase-messaging-bundle.component.html',
  styleUrls: ['./purchase-messaging-bundle.component.scss'],
})
export class PurchaseMessagingBundleComponent implements OnInit {
  private partner: any = {};
  private profile: any = {};
  public credits: any = [];
  public packages: any = [];
  public transactionHistory: any = [];
  public creditTransactionHistory: any = [];
  public paymentStatus = null;
  public payRequestID = null;
  public loadingBundles = false;
  public supportedCountries = [];

  constructor(
    private helpersService: HelpersService,
    private notificationService: NotificationService,
    public messageService: MessageService,
    private translate: TranslateService,
    public confirmationService: ConfirmationService,
    private paymentService: PaymentService,
    private appConfig: AppConfig,
    public modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private countriesService: CountriesService,
    private router: Router,
  ) {
    this.partner = this.helpersService.getPartnerData();
    this.profile = this.helpersService.getProfileData();
  }

  ngOnInit() {
    this.getAvailableCredits();
    this.getAvailableBundles();
    this.getTransactionSummary();
    this.countriesService.getAllCountries().subscribe((countries) => {
      this.supportedCountries = countries.map((x) => {
        return { ...x, label: x.country, value: x.code };
      });
    });
  }

  getAvailableCredits() {
    this.notificationService
      .getAvailableSMSCredits(this.partner.ID)
      .subscribe((credits) => {
        this.credits = credits;
      });
  }

  getAvailableBundles() {
    this.loadingBundles = true;
    this.notificationService
      .getBundlesPerCountry(this.partner.Country ? this.partner.Country : 'ZA')
      .subscribe(
        (packages) => {
          this.packages = packages;
          this.loadingBundles = false;
        },
        (err) => {
          this.loadingBundles = false;
        },
      );
  }

  getTransactionSummary() {
    this.notificationService
      .getTransactionSummary(this.partner.ID, true)
      .subscribe((history) => {
        this.creditTransactionHistory = history;
      });
    this.notificationService
      .getTransactionSummary(this.partner.ID, false)
      .subscribe((history) => {
        this.transactionHistory = history;
      });
  }

  buyBundleConfirm(bundle) {
    this.confirmationService.confirm({
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      header: this.translate.instant('general.confirm'),
      message: this.translate.instant(
        'bikeshop.purchase-messaging-bundle.purchase_confirmation',
      ),
      accept: () => {
        //this.appConfig.getSupportedCountries().filter(x => { return x.value === (this.partner.Country ? this.partner.Country : 'ZA') });
        var country = this.supportedCountries.filter((x) => {
          return (
            x.value === (this.partner.Country ? this.partner.Country : 'ZA')
          );
        });

        if (country.length > 0 && country[0].paymentProvider === 'PAYGATE') {
          this.purchaseBundlePaygate(bundle, country[0]);
        } else if (
          country.length > 0 &&
          country[0].paymentProvider === 'STRIPE'
        ) {
          this.purchaseBundleStripe(bundle, country[0]);
        }
      },
    });
  }

  purchaseBundlePaygate(bundle, country) {
    var data = {
      PAYGATE_ID: this.appConfig.getPaygateId(),
      REFERENCE: this.partner.Name,
      AMOUNT: parseInt(bundle.amount) * 100,
      CURRENCY: bundle.currency,
      RETURN_URL: this.appConfig.getPaygateReturnUrl(), //window.location.origin+this.router.url,
      TRANSACTION_DATE: moment().format('YYYY-MM-DD HH:mm:ss'),
      LOCALE: country.locale.toLowerCase(),
      COUNTRY: country.isO3,
      EMAIL: this.profile.Email,
    };
    this.paymentService
      .getCheckSumPaygateImproved(data)
      .subscribe((checksum) => {
        data = { ...data, ...{ CHECKSUM: checksum } };
        this.paymentService
          .initilizePaygatePayment(data)
          .subscribe((paygateStr) => {
            this.payRequestID = this.getPayRequestID(paygateStr);

            var pay_request_id = this.getPayRequestID(paygateStr);
            if (pay_request_id != null) {
              var paymentInfo = {
                PartnerID: this.partner.ID,
                PaymentProvider: 1, //Paygate
                TypeID: bundle.typeID,
                BundleID: bundle.id,
                Reference: this.partner.Name,
                Identifier: this.payRequestID,
              };
              this.paymentService
                .initializeHubtigerPayment(paymentInfo)
                .subscribe(
                  (success) => {
                    this.paymentStatus = 1; //Initiated
                    this.paymentService.processPaygatePayment(paygateStr);
                    this.pollStatusUpdate();
                  },
                  (err) => {
                    this.messageService.add({
                      life: 5000,
                      detail: this.translate.instant(
                        'bikeshop.purchase-messaging-bundle.issue_initializing_paygate',
                      ),
                    });
                  },
                );
            } else {
              this.messageService.add({
                life: 5000,
                detail: this.translate.instant(
                  'bikeshop.purchase-messaging-bundle.issue_initializing_paygate',
                ),
              });
            }
          });
      });
  }

  getPayRequestID(paygateStr) {
    var fields = paygateStr.split('&');
    var pay_request_id = null;
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].indexOf('PAY_REQUEST_ID') > -1) {
        var pair = fields[i].split('=');
        pay_request_id = pair[1];
      }
    }
    return pay_request_id;
  }

  purchaseBundleStripe(bundle, country) {
    const modalRef = this.modalService.open(StripeBundlePaymentComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'stripe-popout',
    });
    modalRef.componentInstance.bundle = bundle;
    modalRef.componentInstance.country = country;
    modalRef.result.then(
      (result) => {
        this.messageService.add({
          life: 10000,
          detail: this.translate.instant(
            'bikeshop.purchase-messaging-bundle.bundle_purchase_complete',
          ),
        });
        this.getAvailableCredits();
        this.getTransactionSummary();
      },
      (onrejected) => {},
    );
  }

  pollStatusUpdate() {
    setTimeout(() => {
      this.paymentService
        .getPaymentRequestStatus(this.payRequestID)
        .subscribe((status) => {
          this.paymentStatus = status;
          if (status === 1) {
            this.pollStatusUpdate();
          } else if (status === 10) {
            this.getAvailableCredits();
            this.getTransactionSummary();
            this.messageService.add({
              life: 10000,
              detail: this.translate.instant(
                'bikeshop.purchase-messaging-bundle.bundle_purchase_complete',
              ),
            });
          } else {
          }
        });
    }, 20000);
  }
}
